import React from 'react';
import { Link } from 'react-router-dom';
import { cars } from '../data/cars';

const CarCard = ({ car }) => {
  // Find the car ID from the car title (handles "Perodua [Name]" format)
  const carName = car.title.replace('Perodua ', '').trim();
  const carData = cars.find(c => c.name.toLowerCase() === carName.toLowerCase());
  const carId = carData ? carData.id : null;

  return (
    <div className="car-card">
      <div className="car-img" style={{backgroundImage: `url('/${car.image}')`}}></div>
      <div className="car-info">
        <div className="car-title">{car.title}</div>
        <div className="car-price">{car.price}</div>
        <div className="car-meta">
          <span>{car.meta1}</span>
          <span>{car.meta2}</span>
        </div>
        <div className="card-actions">
          {carId ? (
            <Link to={`/car/${carId}`} className="btn-outline">Specs</Link>
          ) : (
            <button type="button" className="btn-outline" disabled aria-disabled="true">
              Specs
            </button>
          )}
          <a href="#advisors" className="btn-fill">Book Now</a>
        </div>
      </div>
    </div>
  );
};

export default CarCard;
